import { RequestInfo } from './requestinforesponse';
import { RequestAdditionalInfo } from './requestadditionalinforesponse';
import { RequestCustomFieldInfo } from './requestcustomfieldinforesponse';
import { RequestNotes } from './requestnotesresponse';

export class RequestDetailResponse {
    requestInfo: RequestInfo;
    requestAdditionalInfo: RequestAdditionalInfo | null;
    requestCustomFieldInfo: RequestCustomFieldInfo[] | null;
    requestNotes: RequestNotes[] | null;
    customFormFields: CustomFormField[] | null;
}

export class RequestDetails {
    requestNumber: number;
    results: RequestDetailResponse | null;
}
export class CustomFormField {
    displayName: string;
    value: string;
}

